import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { sanitizeImgUrl } from '@edulastic/common/src/utils/html'
import CardMapImage from '../../../src/assets/map-card.svg'
import { Content, Header, RoundDiv, StyledPreviewImage } from '../../components'
import { setUserAnswerAction } from '../../../../assessment/actions/answers'
import { BetaTag } from '../../../../common/components/BetaTag'
import { onEnterKeyPressHandler } from '../../../../common/utils/helpers'

const Card = ({
  title,
  cardImage,
  onSelectQuestionType,
  data,
  isBeta = false,
}) => {
  const smallData = {
    ...data,
    smallSize: true,
  }

  return (
    <>
      <RoundDiv
        onClick={() => onSelectQuestionType(smallData)}
        tabIndex="0"
        onKeyDown={(e) =>
          onEnterKeyPressHandler(e, () => onSelectQuestionType(smallData))
        }
        role="button"
        aria-label={`Select ${title} question type`}
        data-cy={title}
      >
        <Header className="card-title">
          {title}
          {isBeta && (
            <>
              &nbsp;
              <BetaTag>BETA</BetaTag>
            </>
          )}
        </Header>
        <Content>
          <StyledPreviewImage
            src={sanitizeImgUrl(cardImage || CardMapImage)}
            alt="Question type preview"
          />
        </Content>
      </RoundDiv>
    </>
  )
}

Card.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  cardImage: PropTypes.object.isRequired,
  onSelectQuestionType: PropTypes.func.isRequired,
}

export default connect(null, { setUserAnswer: setUserAnswerAction })(Card)
